/** Sample order used for canvas preview. */
export const SAMPLE_ORDER = {
  id: 10086,
  order_no: "SO20260909001",
  created_at: "2026-09-09 11:20:00",
  receiver: "阿力木",
  tel: "13800001111",
  zh_address: "乌鲁木齐市天山区建设路88号",
  address: "ئۈرۈمچى شەھەر تىيانشان رايونى",
  ug_address: "ئۈرۈمچى شەھەر تىيانشان رايونى",
  notes: "请尽量上午配送",
  paytype_label: "微信支付",
  ship_price: 5,
  total: 128.5,
  merchant: {
    id: 962,
    name: "初爱摇篮",
    zh_name: "初爱摇篮",
    ug_name: "چۇيەي",
    tel: "0991-8888888",
  },
  details: [
    {
      product: {
        name: "有机奶粉 1段",
        zh_name: "有机奶粉 1段",
        ug_name: "ئورگانىك سۈت پاراشوكى 1-دەرىجە",
        barcode: "6901234567890",
      },
      selected_sku: {
        name: "800g",
        zh_name: "800g",
        ug_name: "800g",
        barcode: "6901234567890",
      },
      price: 298,
      amount: 1,
      base_unit: { name: "罐", zh_name: "罐", ug_name: "قۇتا" },
    },
    {
      product: {
        name: "湿巾",
        zh_name: "湿巾",
        ug_name: "ھۆل قولياغلىق",
        barcode: "6909876543210",
      },
      selected_sku: {
        name: "80抽*3",
        zh_name: "80抽*3",
        ug_name: "80 تال*3",
        barcode: "6909876543210",
      },
      price: 29.9,
      amount: 2,
      base_unit: { name: "包", zh_name: "包", ug_name: "بوغچا" },
    },
    {
      product: {
        name: "纸尿裤 L",
        zh_name: "纸尿裤 L",
        ug_name: "بالىلار پەمپىرسى L",
        barcode: "6911122233344",
      },
      selected_sku: {
        name: "54片",
        zh_name: "54片",
        ug_name: "54 پارچە",
        barcode: "6911122233344",
      },
      price: 89.9,
      amount: 1,
      base_unit: { name: "包", zh_name: "包", ug_name: "بوغچا" },
    },
  ],
};
